module.exports = __webpack_public_path__ + "static/media/all-happiness.74262941.svg";